<h2 class="page-header">Stock locaties</h2>
<div *ngIf="loadingLocations">
  <mat-spinner color="primary" diameter="24"></mat-spinner>
</div>
<div
  class="flex-table stock-table"
  *ngIf="!loadingLocations && locations != null"
>
  <div class="flex-header-row">
    <div class="flex-table-cell flex-3">Rek</div>
    <div class="flex-table-cell flex-3">Schap</div>
    <div class="flex-table-cell flex-3">Vak</div>
    <div class="flex-table-cell flex-1"></div>
  </div>
  <div class="flex-table-row" *ngFor="let location of locations; index as i">
    <div class="flex-table-cell flex-3">{{ location.rack }}</div>
    <div class="flex-table-cell flex-3">{{ location.shelf }}</div>
    <div class="flex-table-cell flex-3">{{ location.compartment }}</div>
    <div class="flex-table-cell flex-1">
      <mat-menu #actionMenu="matMenu" class="table-text">
        <button
          mat-menu-item
          (click)="editLocation(location, i)"
          class="center-text"
        >
          Aanpassen
        </button>
      </mat-menu>
      <mat-icon class="fa-2x clickable" [matMenuTriggerFor]="actionMenu"
        >more_vert</mat-icon
      >
    </div>
  </div>
</div>
<div class="pull-left clickable" (click)="addLocation()">
  <mat-icon svgIcon="add"></mat-icon>
</div>
<mat-paginator
  [length]="totalItems"
  [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="true"
></mat-paginator>
